import { render, staticRenderFns } from "./StockScreen2.vue?vue&type=template&id=4c4d7383&"
import script from "./StockScreen2.vue?vue&type=script&lang=js&"
export * from "./StockScreen2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports